/** URLs and addresses used across the marketing site. */
export const APP_URL: string = (import.meta.env.VITE_APP_URL || "https://app.mineoptics.com").replace(/\/$/, "");
export const SIGNUP_URL = `${APP_URL}/auth/signup`;
export const LOGIN_URL = `${APP_URL}/auth/login`;
export const DOCS_URL = "https://docs.mineoptics.com";
export const CONTACT_EMAIL = "hello@mineoptics.com";

export const isExternal = (to: string) => /^(https?:|mailto:)/.test(to);
